import React from "react";
import SvgIcon from "../parts/SvgIcon";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.setHasError = this.setHasError.bind(this);
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    // logErrorToMyService(error, info.componentStack);
  }

  componentDidMount() {
    window.addEventListener("popstate", this.setHasError, false);
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.setHasError, false);
  }

  setHasError(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.state.hasError) {
      this.setState({ hasError: false });
      location.reload();
    }
  }

  render() {
    if (this.state.hasError && this.props.fallback) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }
    if (this.state.hasError && !this.props.fallback) {
      return (
        <div id="error-wrapper" className="error-boundary">
          <SvgIcon
            src={"/img/new-icons/msb-logo-not-extended.svg"}
            noFilterOnLight={true}
          />
          <h1>Oops! Something went wrong.</h1>
          <p className="p2">
            Reload the page, and if the issue persists, contact support at{" "}
          </p>
          <a style={{ color: "#04A1E1" }} href="mailto:info@mystrengthbook.com">
            info@mystrengthbook.com
          </a>
          <button
            onClick={(e) => {
              e.preventDefault();
              history.back();
            }}
            data-button-type="primary"
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children || null;
  }
}

export default ErrorBoundary;
